import {useEffect, useState, useRef, useMemo} from 'react';
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Form, Select, Tag} from 'antd';
import {getAll, drop} from '../../../../apis/OdooTimeLeaveApi';
import { getList as getLeaveTypes } from '../../../../apis/OdooLeaveTypeApi';
import dayjs from 'dayjs';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Captura</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Tiempos de Personal</span>
      </>
    ),
  }];

const TimeLeave = () => {
    const [form] = Form.useForm();
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [tipoAusencia, setTipoAusencia] = useState(null);
    const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);

    const columns = [
      {
        title: 'Empleado',
        dataIndex: 'empleado.name',
        key: 'empleado.name',
        render: (item, object)=> {
          return <Space>
            <span>{object.empleado.name}</span>
          </Space>
        }
      },
      {
        title: 'Tipo de Ausencia',
        dataIndex: 'holiday_status_name',
        key: 'holiday_status_name',
        render: (value) => value || '-',
      },
      {
        title: 'Descripcion',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Fecha Desde',
        dataIndex: 'date_from',
        key: 'date_from',
        render: (value) => value ? dayjs(value).format('DD/MM/YYYY') : '-',
      },
      {
        title: 'Fecha Hasta',
        dataIndex: 'date_to',
        key: 'date_to',
        render: (value) => value ? dayjs(value).format('DD/MM/YYYY') : '-',
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setobjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el tiempo de ausencia?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El tiempo de ausencia ha sido eliminado!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setobjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const getLeaveTypesOdoo = async () => {
      const response = await getLeaveTypes();
      if (response?.ok) {
        setLeaveTypes(response.payload || []);
      }
    };

    const onBlurPeriodo = async (values, period) => {
      setPeriodoSeleccionado(
        period?.periodoCompleto?.fecha_inicial && period?.periodoCompleto?.fecha_final
          ? period.periodoCompleto
          : null
      );
    };

    const limpiarFiltros = () => {
      setTipoAusencia(null);
      setPeriodoSeleccionado(null);
      form.resetFields();
    };

    const hayFiltros = Boolean(tipoAusencia || periodoSeleccionado);

    // Solape entre el rango de la ausencia [date_from, date_to] y el rango del periodo.
    // Criterio alineado con el backend (odoo_timeleave_service: date_from <= fin AND date_to >= ini).
    const itemsFiltrados = useMemo(() => {
      let resultado = items;

      if (tipoAusencia) {
        resultado = resultado.filter((item) => String(item.holiday_status_id) === String(tipoAusencia));
      }

      if (periodoSeleccionado?.fecha_inicial && periodoSeleccionado?.fecha_final) {
        const iniPeriodo = dayjs(periodoSeleccionado.fecha_inicial).startOf('day');
        const finPeriodo = dayjs(periodoSeleccionado.fecha_final).startOf('day');

        resultado = resultado.filter((item) => {
          if (!item.date_from || !item.date_to) return false;
          const iniAusencia = dayjs(item.date_from).startOf('day');
          const finAusencia = dayjs(item.date_to).startOf('day');
          // Solape: inicioAusencia <= finPeriodo AND finAusencia >= iniPeriodo
          return iniAusencia.valueOf() <= finPeriodo.valueOf()
            && finAusencia.valueOf() >= iniPeriodo.valueOf();
        });
      }

      return resultado;
    }, [items, tipoAusencia, periodoSeleccionado]);

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
          await getLeaveTypesOdoo();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp 
      routes={routes}
      title={'Tiempos de Personal'} 
      cardTitle='Lista de tiempos de personal'
      extraCard={[
        <Button type="primary" onClick={btnClick}>
          Agregar Tiempo de Personal
      </Button>
      ]}>
      <div style={{ marginBottom: 16 }}>
        <AnioPeriodo onBlur={onBlurPeriodo} form={form} disabledForm={false} />
      </div>
      <Space wrap style={{ marginBottom: 16 }}>
        <Select
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="Filtrar por tipo de ausencia"
          style={{ width: 260 }}
          value={tipoAusencia}
          onChange={(value) => setTipoAusencia(value ?? null)}
          options={leaveTypes.map((item) => ({
            value: item.id,
            label: item.display_name || item.name,
          }))}
        />
        <Button onClick={limpiarFiltros} disabled={!hayFiltros}>
          Limpiar filtros
        </Button>
        <Tag color="blue">
          {itemsFiltrados.length} de {items.length} registro(s)
        </Tag>
      </Space>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              itemsFiltrados.length == 0 ? <Empty />:
              <Table dataSource={itemsFiltrados} columns={columns} rowKey="id" />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Tiempo de Personal"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Tiempo de Personal"} open={openEdit} finish={onHandlerFinish}/>
      }
      
    </PageApp>
}   

export default TimeLeave;
